import React from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { useOverlayContext } from '@/app/common/context/OverlayContext.ts';
import BasicModalHeader from '../BasicModalHeader';
import BasicModalHeaderV2 from '../BasicModalHeaderV2';

// `removeShadow` / `closeOnRight` only affect the legacy (V1) header; V2's shadow is scroll-driven
// (via OverlayContext) and its close button always sits top-right, so they're ignored in the Evo path.
// MPH-832: `disableScrollShadow` opts a V2 header out of that scroll-driven shadow, for modals whose
// own content already owns the separator (the change-flight drawer's sticky filters block) — with both
// drawing it, a grey band appears between the title and the filters.
type ModalHeaderProps = Omit<React.ComponentProps<typeof BasicModalHeaderV2>, 'showShadow'> & {
  removeShadow?: boolean;
  closeOnRight?: boolean;
  disableScrollShadow?: boolean;
};

const ModalHeader = ({ removeShadow, closeOnRight, disableScrollShadow, ...props }: ModalHeaderProps) => {
  const { isEvoLayout } = useCommonClient();
  const { headerShadow } = useOverlayContext();
  if (isEvoLayout) return <BasicModalHeaderV2 showShadow={!disableScrollShadow && headerShadow} {...props} />;
  const { handleClose, children, className, style, closeLabel } = props;
  return (
    <BasicModalHeader
      handleClose={handleClose}
      className={className}
      style={style}
      removeShadow={removeShadow}
      closeOnRight={closeOnRight}
      closeLabel={closeLabel}
    >
      {children}
    </BasicModalHeader>
  );
};

export default ModalHeader;
